import type { GlobalCollectionId, GlobalFieldId, GlobalPrimitiveFieldId, GlobalSingleRelationFieldId } from '#layers/data-model/types/schema/ids';
import type {
	ResolvedMonospaceCollection,
	ResolvedMonospaceDataSource,
	ResolvedMonospaceIndex,
	ResolvedMonospacePrimitiveField,
	ResolvedMonospaceSingleRelationField,
} from '#layers/data-model/types/schema/resolved-schema';

function sourceRouteParams(source?: ResolvedMonospaceDataSource) {
	return {
		source: source?.apiName,
	};
}

function collectionRouteParams(collection?: ResolvedMonospaceCollection | {
	source: ResolvedMonospaceDataSource;
	id: GlobalCollectionId;
	dbName?: string;
}) {
	return {
		...sourceRouteParams(collection?.source),
		collection: collection?.dbName ?? collection?.id,
	};
}

export function getCanonicalSourceRoute(source: ResolvedMonospaceDataSource) {
	return {
		name: 'data-model.source',
		params: sourceRouteParams(source),
	};
}

export function getCanonicalCollectionRoute(collection: ResolvedMonospaceCollection | {
	source: ResolvedMonospaceDataSource;
	id: GlobalCollectionId;
	dbName?: string;
}) {
	return {
		name: 'data-model.source.collection',
		params: collectionRouteParams(collection),
	};
}

export function getCanonicalFieldEditRoute(field: ResolvedMonospacePrimitiveField | ResolvedMonospaceSingleRelationField | {
	collection: ResolvedMonospaceCollection;
	id: GlobalFieldId;
}) {
	return {
		name: 'data-model.source.collection.field',
		params: {
			...collectionRouteParams(field.collection),
			field: 'dbName' in field ? field.dbName : ('apiName' in field ? field.apiName : field.id),
		},
	};
}

export function getCanonicalColumnEditRoute(field: ResolvedMonospacePrimitiveField | {
	collection: ResolvedMonospaceCollection;
	id: GlobalPrimitiveFieldId | '+';
}) {
	return {
		name: 'data-model.source.collection.column',
		params: {
			...collectionRouteParams(field.collection),
			column: 'dbName' in field ? field.dbName : field.id,
		},
	};
}

export function getCanonicalRelationEditRoute(field: ResolvedMonospaceSingleRelationField | {
	collection: ResolvedMonospaceCollection;
	id: GlobalSingleRelationFieldId | '+';
}) {
	return {
		name: 'data-model.source.collection.relation',
		params: {
			...collectionRouteParams(field.collection),
			relation: 'apiName' in field ? field.apiName : field.id,
		},
	};
}

export function getCanonicalIndexEditRoute(index: ResolvedMonospaceIndex | {
	collection: ResolvedMonospaceCollection;
	id: string;
}) {
	return {
		name: 'data-model.source.collection.index',
		params: {
			...collectionRouteParams(index.collection),
			indexName: 'dbName' in index ? index.dbName : index.id,
		},
	};
}
